import { ExplorableItemDefinition } from './ContentDefinitionsTypes';
import { Messages } from '../../../codegen/Localize';
import { DatabaseContentType, DatabaseWithCrassContentType } from '../ContentTypes';
import { getGenericDefaultFilters } from './getDefaultFilters';
import { GenericCard } from '../../../app/spaces/CardView/GenericCard';
import { DatabasesWithCrass } from '../../../catalog/resources/DatabasesWithCrass';
import { DatabasesGraphQLResourceQuery } from '../../../catalog/fetchers/DatabasesGraphQLResourceQuery';

export const DatabaseWithCrassDefinition: ExplorableItemDefinition = {
  itemType: 'databaseWithCrass',
  pluralName: () => Messages.databasesAndFiles(),
  emptyStateMessage: () => Messages.databasesAndFilesEmptyMessage(),
  contentFilterKeys: DatabaseWithCrassContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: GenericCard,
  listViewIconUrl: null,
  filterClause: null,
  getBasicQuery: () => {
    return DatabasesWithCrass.all().withExtraParams(DatabaseContentType.extraQueryParams);
  },
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list'],
};
export const DatabaseDefinition: ExplorableItemDefinition = {
  itemType: 'database',
  pluralName: () => Messages.databasesAndFiles(),
  emptyStateMessage: () => Messages.databasesAndFilesEmptyMessage(),
  contentFilterKeys: DatabaseContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: GenericCard,
  listViewIconUrl: null,
  filterClause: null,
  getBasicQuery: () => new DatabasesGraphQLResourceQuery(),
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list'],
};
